import { createFileRoute, redirect } from '@tanstack/react-router';
import { env } from '../lib/env';
import { isAuthenticated } from '../lib/auth';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
  },
  component: HomePage,
});

function HomePage() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">Teraseya Fly v2</h1>
      <p className="text-neutral-600">
        Frontend running on stage <code className="rounded bg-neutral-200 px-1">{env.stage}</code>.
      </p>
    </div>
  );
}
